<template>
    <modal title="Dokument hinzufügen" :showDismissMessage="showDismissMessage">
        <form @submit.prevent="submitForm">
            <ion-grid>
                <ion-row>
                    <ion-col class="ion-margin-bottom">
                        Erlaubte Dateiformate: <b>PDF</b>, <b>TIFF</b>,
                        <b>JPEG</b> und <b>PNG</b>. <br />
                        Die maximale Dateigröße beträgt <b>5MB</b>.
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col class="ion-margin-bottom">
                        <files-upload
                            v-model="checklistfile"
                            id="checklistfile"
                        ></files-upload>
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col class="ion-margin-bottom">
                        <!-- <base-textarea
                        id="description"
                        v-model="description"
                        label="Beschreibung"
                        ></base-textarea> -->

                        <base-input
                            type="text"
                            v-model="description"
                            label="Titel"
                            id="description"
                        ></base-input>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </form>
        <template v-slot:footer>
            <ion-button
                @click="submitForm()"
                expand="block"
                class="ion-margin-top"
                :disabled="
                    checklistfile.length === 0 || description === ''
                        ? true
                        : false
                "
            >
                <span
                    class="icon-hochladen ion-margin-end"
                    slot="start"
                    style="font-size: x-large;"
                ></span>
                <ion-label>Dokument hinzufügen</ion-label>
            </ion-button>
        </template>
    </modal>
</template>

<script>
import Modal from "./Modal";
// import BaseTextarea from "./BaseTextarea";
import BaseInput from "./BaseInput";
import FilesUpload from "@/components/FilesUpload";
import { uploadChecklist } from "@/api/kreditcheckliste";

export default {
    props: ["checklistItemId"],
    components: {
        Modal,
        // BaseTextarea,
        BaseInput,
        FilesUpload,
    },
    data() {
        return {
            description: "",
            checklistfile: [],
            showDismissMessage: false,
        };
    },
    watch: {
        description() {
            this.showDismissMessage = true;
        },
        checklistfile() {
            this.showDismissMessage = true;
        },
    },
    methods: {
        submitForm() {
            this.$store.commit("setLoading", true);
            uploadChecklist(
                this.description,
                this.checklistItemId,
                this.checklistfile[0]
            ).then((response) => {
                if (response.data.Status === 200) {
                    if (response.data.Result) {
                        this.$store.dispatch(
                            "kreditcheckliste/getChecklistsEntries"
                        );
                        this.$ionic.modalController.dismiss();
                        this.$ionic.alertController
                            .create({
                                header:
                                    "Dokument wurde erfolgreich hochgeladen",
                                // message: "Möchtest du dieses Dokument wirklich löschen?",
                                buttons: [
                                    {
                                        text: "Ok",
                                        role: "cancel",
                                    },
                                ],
                            })
                            .then((a) => {
                                a.onDidDismiss().then(() => {
                                    this.$store.commit("setAskForRating", true);
                                });
                                a.present();
                            });
                    }
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped></style>
